import { apiPostAsync } from '../common/service-utils'
import * as constants from '../common/constants'

const DEFAULT_TIMEOUT_MS = 5000;
const MAX_ERROR_CHARS = 500;

function timeoutMsFrom(connectivityTest) {
    const timeoutMs = Number(connectivityTest && connectivityTest.timeoutMs);
    return timeoutMs > 0 ? timeoutMs : DEFAULT_TIMEOUT_MS;
}

function probeOne(url, timeoutMs) {
    const started = Date.now();
    let controller = null;
    try {
        controller = new AbortController();
    } catch (e) {
        controller = null;
    }
    const specs = {
        method: 'GET',
        mode: 'no-cors',
        credentials: 'omit',
        cache: 'no-store',
    };
    if (controller) {
        specs.signal = controller.signal;
    }
    const timer = setTimeout(() => {
        if (controller) {
            controller.abort();
        }
    }, timeoutMs);
    const timedOut = new Promise(resolve => setTimeout(() => resolve({
        url,
        reachable: false,
        statusCode: null,
        responseTimeMs: timeoutMs,
        error: 'timeout',
    }), timeoutMs));
    return Promise.race([fetch(url, specs)
        .then(() => ({
            url,
            reachable: true,
            statusCode: null,
            responseTimeMs: Date.now() - started,
            error: null,
        }))
        .catch(err => ({
            url,
            reachable: false,
            statusCode: null,
            responseTimeMs: Date.now() - started,
            error: String(err && err.message ? err.message : err).slice(0, MAX_ERROR_CHARS),
        }))
        .then(result => {
            clearTimeout(timer);
            return result;
        }), timedOut]);
}

export function probeConnectivityUrls(connectivityTest) {
    if (!connectivityTest || !Array.isArray(connectivityTest.urls) || !connectivityTest.urls.length) {
        return Promise.resolve([]);
    }
    const timeoutMs = timeoutMsFrom(connectivityTest);
    return Promise.all(connectivityTest.urls.map(url => probeOne(url, timeoutMs)));
}

// The SSO argument layer exposes the posted JSON as Map<String,String>, so a nested array of
// objects is rejected before the API method runs. Serialize it, as saveUserPreference does.
export function reportConnectivityTestResults(appKey, results, timeoutMs = DEFAULT_TIMEOUT_MS) {
    return apiPostAsync(constants.API_LOG_CONNECTIVITY_TEST_RESULTS, null,
        { appKey, results: JSON.stringify(results) }, timeoutMs)
        .catch(() => {});
}

export function runConnectivityProbeThenReport(connectivityTest) {
    if (!connectivityTest || !Array.isArray(connectivityTest.urls) || !connectivityTest.urls.length) {
        return Promise.resolve();
    }
    const timeoutMs = timeoutMsFrom(connectivityTest);
    return probeConnectivityUrls(connectivityTest)
        .then(results =>
            reportConnectivityTestResults(connectivityTest.application, results, timeoutMs))
        .catch(() => {});
}
